import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/videos/create-from-client/'
)({
  // This wizard only supported the retired before-after template. Preserve
  // bookmarked URLs without mounting a flow that can still create its drafts.
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/l/$locationId/marketing/gallery',
      params: { locationId: params.locationId },
    });
  },
});
